const TABS = [
  ["galeria", "Galería y votos"],
  ["participar", "Sube tu león"],
  ["resultados", "Resultados"],
  ["admin", "Admin"],
];

export const Tabs = ({ tab, isAdmin }) => (
  <nav className="tabs">
    <div className="wrap">
      {TABS.filter(([k]) => k !== "admin" || isAdmin).map(([k, label]) => (
        <a key={k} href={`#${k}`} className={tab === k ? "on" : ""} data-testid={`tab-${k}`}
          ref={(el) => tab === k && el?.scrollIntoView({ inline: "nearest", block: "nearest" })}>{label}</a>
      ))}
    </div>
  </nav>
);
